export const investmentOptions = [
  "Venture Capital",
  "Real Estate",
  "Fixed Income",
  "Private Equity",
  "Sukuk",
];
